import { flatMap, orderBy, values, isEmpty, filter, isNumber, findIndex } from 'lodash';

export function getPages(state, getters) {
  const cardId = getters.getCardId;

  if (!isEmpty(getters.getWrongPages)) {
    return getters.getWrongPages || {};
  }

  return state.cardPages[cardId] || {};
}


export function getWrongPages(state) {
  return state.wrongPages || {};
}

export function getPageList(state, getters) {
  const pageList = flatMap(getters.getPages);

  return orderBy(pageList, 'position', 'asc');
}

export function getFilterWrongPages(state, getters) {
  if (isEmpty(getters.getPageList)) {
    return [];
  }

  return filter(values(getters.getPageList), (item) => {
    if (item.submitted_answers) {
      return (item.submitted_answers[0] && item.submitted_answers[0].is_correct) === false;
    }
    return {};
  });
}

/* eslint-disable no-param-reassign */
export function getWrongPageList(state, getters) {
  if (isEmpty(getters.getFilterWrongPages)) {
    return [];
  }

  return getters.getFilterWrongPages.reduce((result, item, index) => {
    result[index + 1] = item;
    return result;
  }, {});
}
/* eslint-enable */

export function getPagesPagination(state) {
  return state.pagination;
}

export function getPageNumber(state, getters) {
  if (
    !isEmpty(getters.getPagesPagination)
    && Number(getters.getPagesPagination.page) >= 1
  ) {
    return getters.getPagesPagination.page;
  }

  const pageNumber = Number(getters.getRouteParams.page);

  if (!isNumber(pageNumber) || pageNumber < 1) {
    return 1;
  }

  return pageNumber;
}

export function getNextPagination(state, getters) {
  return getters.getPageId + 1;
}

export function getPreviousPageId(state, getters) {
  return getters.getPageId - 1;
}

export function getPagesCount(state) {
  return Object.keys(state.pages).length;
}

export function getPageId(state, getters) {
  return Number(getters.getRouteParams.page);
}

export function getPage(state, getters) {
  const cardId = getters.getCardId;
  const pageId = getters.getPageId;

  if (!state.cardPages[cardId]) {
    return {};
  }

  if (!isEmpty(getters.getWrongPages)) {
    const pagePosition = getters.getPagesPagination && getters.getPagesPagination.page;
    return getters.getWrongPages[pagePosition] || {};
  }

  return state.cardPages[cardId][pageId] || {};
}

export function getOptions(state, getters) {
  return getters.getPage.answers || [];
}

export function getIsEnd(state, getters) {
  return getters.getCard &&
    (getters.getCard.due_date_passed ||
    (new Date(getters.getCard.due_date).getTime()) < (new Date().getTime()));
}

export function getPagesMetaInfo(state, getters) {
  const cardMetaInfo = getters.getCardMetaInfo;

  return {
    ...cardMetaInfo,
  };
}

export function getCorrectOptionIndex(state, getters) {
  return getters.getOptions.findIndex(option => option.is_correct) + 1;
}

export function getCorrectAnswerContents(state, getters) {
  return getters.getOptions.filter(answer => (
    answer.is_correct
  ))
    .map(answer => (answer.content)).join(', ');
}

export function getSelectedOptionIndex(state, getters) {
  if (isEmpty(getters.getQuizResult)) {
    return null;
  }

  const selectedOptionIndex = findIndex(getters.getOptions, option =>
    Number(option.id) === Number(getters.getQuizResult.answer_id),
  );

  return selectedOptionIndex + 1;
}

export function getQuizAnswerValue(state, getters) {
  return getters.getQuizResult.value;
}

export function getIsResult(state, getters) {
  return getters.getPage.is_result_cover;
}

export function getIsOptionsBlank(state, getters) {
  return getters.getPage &&
    getters.getPage.answers &&
    getters.getPage.answers.every(answer => !answer.content);
}

export function getPreEnteredValue(state, getters) {
  if (isEmpty(getters.getPage)) {
    return '';
  }

  return state.preEnteredValues[getters.getPage.id] || '';
}

export function getPreselectedOption(state, getters) {
  return state.preselectedOption[getters.getPage.id] || {};
}

export function getSelectedOptions(state) {
  return state.selectedOptions;
}

export function getEnteredValue(state) {
  return state.enteredValue;
}

export function getQuizStartTime(state) {
  return state.startTime.getTime();
}

export function getPageTypeName(state, getters) {
  if (isEmpty(getters.getPage)) return '';

  return getters.getPage.page_type.name;
}

export function isInvalidEnteredValueLines(state, getters) {
  if (!getters.getEnteredValue) return false;

  const numberOfLines = (getters.getEnteredValue.match(/\n/g) || []).length + 1;

  if (getters.getPageTypeName === 'essay_type' && numberOfLines > 50) {
    return true;
  }

  if (getters.getPageTypeName === 'text_entry' && numberOfLines > 2) {
    return true;
  }

  return false;
}
